import 'whatwg-fetch';

import * as constants from '../constants/actions';
import * as endpoint from '../constants/endpoints';
import * as api from '../constants/api';

import {parseJSON,isOk,authReq} from '../utils/request';


/******************************
*******  Synchronous  *********
******************************/


export function productSaveDiamondResults(diamonds, diamondCount = 0) {
	return {
    type: constants.PRODUCT_SAVE_DIAMONDS,
    diamonds,
    diamondCount
  };
}

export function productAppendDiamondResults(diamonds) {
  return {
    type: constants.PRODUCT_APPEND_DIAMONDS,
    diamonds,
  };
}

export function productAddDiamondResults(diamonds, diamondPage) {
  return {
    type: constants.PRODUCT_ADD_DIAMONDS,
    diamonds,
    diamondPage
  };
}

export function productSaveResults(products, productCount = 0) {
  return {
    type: constants.PRODUCT_SAVE_SETTINGS,
    products,
    productCount,
  };
}

export function productSaveDiamondQueryFilters(filters, pageNum = 1) {
  return {
    type: constants.PRODUCT_SAVE_DIAMOND_QUERY,
    filters,
    pageNum,
  };
}

export function productResetDiamondQueryFilters() {
  return {
    type: constants.PRODUCT_RESET_DIAMOND_QUERY,
  };
}

export function productSaveProductQueryFilters(filters, queryType, pageNum = 1) {
  return {
    type: constants.PRODUCT_SAVE_SETTING_QUERY,
    filters,
    queryType,
    pageNum,
  };
}

export function productResetProductQueryFilters(queryType) {
  return {
    type: constants.PRODUCT_RESET_PRODUCT_QUERY,
    queryType
  };
}

export function productClearFilters() {
  return {
    type: constants.PRODUCT_CLEAR_QUERY,
  };
}

export function productSelectSetting(setting, metalType = null, ringSize = null) {
  return {
    type: constants.PRODUCT_SELECT_SETTING,
    setting,
    metalType,
    ringSize,
  };
}

export function productSelectDiamond(diamond) {
  return {
    type: constants.PRODUCT_SELECT_DIAMOND,
    diamond
  };
}

export function productCompareSetting(setting) {
  return {
    type: constants.PRODUCT_COMPARE_SETTING,
    setting
  };
}

export function productCompareDiamond(diamond) {
  return {
    type: constants.PRODUCT_COMPARE_DIAMOND,
    diamond
  };
}

export function productCompareBand(band) {
  return {
    type: constants.PRODUCT_COMPARE_BAND,
    band
  };
}

export function productCompareFashion(jewelry) {
  return {
    type: constants.PRODUCT_COMPARE_FASHION,
    jewelry
  };
}

export function productSetPage(page = 1) {
  return {
    type: constants.PRODUCT_SET_PAGE,
    page
  };
}

export function productAttrSize(size = '') {
  return {
    type: constants.PRODUCT_ATTR_SIZE,
    size
  };
}

export function productAttrMetal(metal = '') {
  return {
    type: constants.PRODUCT_ATTR_METAL,
    metal
  };
}

export function productToggleFloatingHeader(position) {
  return {
    type: constants.PRODUCT_FLOATING_HEADER_TOGGLE,
    position
  }
}


/******************************
*******  Asynchronous  ********
******************************/





export function productFetchDiamonds(queryString) {
  return dispatch => {
    let url = api.DIAMOND_API + endpoint.PRODUCT_DIAMONDS + '?format=json&' + queryString;

    return fetch(url, {
      method: 'get',
      headers: api.HEADERS
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}

export function productAddDiamonds(queryString, pageNum) {
  return dispatch => {

    const pageQueryString = queryString === '' ? `page=${pageNum}` : `&page=${pageNum}`;

    const url = api.DIAMOND_API + endpoint.PRODUCT_DIAMONDS + '?format=json&' + queryString + pageQueryString;

    return fetch(url, {
      method: 'get',
      headers: api.HEADERS
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}


export function productFetchDiamondById(diamondId) {
  return dispatch => {
    let url = api.DIAMOND_API + endpoint.PRODUCT_DIAMOND_BY_ID + '?id=' + diamondId;
    return fetch(url, {
      method: 'get',
      headers: api.HEADERS
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}


export function productFetchProducts(queryString, signal = null) {
  return dispatch => {
    let url = api.PRODUCT_API + endpoint.PRODUCT_SETTINGS + '?' + queryString;
    return fetch(url, {
      method: 'get',
      headers: api.HEADERS,
      signal
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}

export function productFetchBySku(settingSku) {
  return dispatch => {
    let url = api.PRODUCT_API + endpoint.PRODUCT_SETTING_BY_SKU + '?sku=' + settingSku;
    return fetch(url, {
      method: 'get',
      headers: api.HEADERS
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}

export function productFetchSearchResults(searchTerm, sortVal='') {
  return dispatch => {
    let url = api.PRODUCT_API + endpoint.PRODUCT_SEARCH + '?q=' + encodeURIComponent(searchTerm);
    if(sortVal) {
      url = url + '&sort=' + sortVal;
    }
    return fetch(url, {
      method: 'get',
      headers: api.HEADERS
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}

export function productHkDiamondAvailability(stockNo) {
  return dispatch => {

    const url = api.MAGENTO_API + endpoint.MAGENTO_CHECK_HK_STATUS + '?stockNo=' + stockNo;
    return fetch(url, {
      method: 'get',
      headers: api.HEADERS
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/product.jsx